var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 pb-4 z-indez-901"},[_c('GmapAutocomplete',{staticClass:"w-100 z-index-901",attrs:{"placeholder":"Inserisci il luogo di partenza"},on:{"place_changed":_vm.handlePlaceChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }